// Interfaces
import { cloneElement, Fragment, isValidElement, ReactElement } from "react";
import { ISideTreeContent, ISideTreeTooltip } from "../../interfaces";

// Components
import SideTreeLabel from "../SideTreeLabel";

// MUI
import { Stack, Tooltip, Typography } from "@mui/material";

const getTooltipTitle = (args: ISideTreeTooltip) => {
	const { title = "", component = null } = args;

	if (component && Boolean(isValidElement(component))) {
		return <Fragment>{cloneElement(component as ReactElement, { ...args })}</Fragment>;
	}

	return <Typography className="!font-regular-sans !text-[12px]">{title}</Typography>;
};

export default function SideTreeTooltip(props: Readonly<ISideTreeContent>) {
	const { title = "", tooltip = null } = props;

	const titleToUse = tooltip?.title ?? title;
	const tooltipTitle = getTooltipTitle({ ...tooltip, title: titleToUse });
	const placement = tooltip?.placement ?? "right";

	return (
		<Tooltip title={tooltipTitle} arrow placement={placement}>
			<Stack>
				<SideTreeLabel {...props} title={title} />
			</Stack>
		</Tooltip>
	);
}
